import React, { useState, useEffect } from "react";

// import Navigation from "../components/navigation/Navigation";
import Head from "../components/head/Head";
import Projets from "../components/projets/Projets";
import Skills from "../components/skills/Skills";
import Footer from "../components/footer/Footer";
import Soft from "../components/soft-skills/Soft";
import Contact from "../components/contact/Contact";
import ModalAlternance from "../components/modal/ModalAlternance";

import skillsData from "../data/skillsData";

const Portfolio = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsModalOpen(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);
  return (
    <section>
      <div className="body">
        <Head />
        <Projets />
        <ModalAlternance isOpen={isModalOpen} onRequestClose={closeModal} />
        <div>
          {" "}
          <Skills skillsData={skillsData} />
        </div>
        <Soft />
        <Contact />
      </div>
      <Footer />
    </section>
  );
};

export default Portfolio;
